<script>
    import { formatTimestamp, getTimestamp } from '../../Utilities/time_format';
    import {clean} from '../../Utilities/Cleaner.svelte';
    import markdown from '../../Utilities/markdown';
    import {session, userMap} from '../../Utilities/Session.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from "@beyonk/svelte-notifications";
    import MetadataTag from './MetadataTag.svelte';

    export let assessment;
    export let assessment_model;

    export let metadata = {};

    let notes = [];
    let replies = {};

    function addComment(evt) {
        let note_text = evt.target.comment.value;

        if (!note_text) return;

        assessment_model.addReportNote(note_text, metadata);

        //reset form
        evt.target.reset();
        evt.target.comment.focus();
    }

    function resolveComment(comment) {
        comment.resolved = {
            ts: +(new Date()),
            user: $session.user.name
        }

        assessment_model.updateReportNote(comment).then(() => {
            notifier.success("Comment Resolved");
        })
    }

    function editComment(comment) {
        addFormModal({
            fields: [{
                name: "note",
                label: "Comment",
                type: "textarea",
                required: true
            }],
            title: "Edit comment",
            data: comment,
            showDelete: true,
        }).then(data => {
            assessment_model.updateReportNote(data);
        }).catch((reason) => {
            if (reason == "delete") {
                confirm("Are you sure you want to delete this comment?").then(() => {
                    assessment_model.deleteReportNote(comment).then( () => {
                        notifier.success("Comment Deleted");
                    });
                }).catch(err => {});
            }
        })
    }

    function replyTo(note) {
        addFormModal({
            fields: [{
                name: "note",
                label: "Comment",
                type: "textarea",
                required: true
            }],
            title: "Reply"
        }).then(data => {
            assessment_model.addReportNote(data.note, {}, note._id);
        })
    }

    function loadNotes(n) {
        notes = [];
        replies = {};

        for (let note of n) {
            if (note.parent) {
                if (!replies[note.parent]) {
                    replies[note.parent] = [note]
                } else {
                    replies[note.parent] = [...replies[note.parent], note]
                }
            } else {
                notes = [...notes, note];
            }
        }
    }

    $: loadNotes($assessment.report_notes)
</script>

<h2 class="title is-2">Peer Review</h2>

<div class="messages">
    {#each notes as note}
        <article class="media">
            <div class="media-content">
                <div class="content">
                    <div class="is-size-6">
                        <div>
                            <strong>{$userMap[note.user] || note.user}</strong>
                            <small>
                                {#if note.ts}
                                    {formatTimestamp(note.ts)}
                                {:else}
                                    {note.timestamp}
                                {/if}
                                {#if $session.user.email == note.user}
                                    <span class="icon pointer" on:click={() => editComment(note)}>
                                        <i>✏️</i>
                                    </span>
                                {/if}
                            </small>
                        </div>
                        <div class="metadata">
                            <MetadataTag metadata={note.metadata} />
                        </div>

                        <div class="comment">
                            {@html clean(markdown(note.note))}
                        </div>
                        <div class="resolved">
                            {#if note.resolved}
                                <div class="tags has-addons" title="{formatTimestamp(note.resolved.ts)}">
                                    <span class="tag is-light is-info">Resolved</span>
                                    <span class="tag">{$userMap[note.resolved.user] || note.resolved.user}</span>
                                </div>
                            {:else}
                                <div class="button is-small" on:click={() => resolveComment(note)}>Mark Resolved</div>
                            {/if}
                        </div>


                        {#if replies[note._id]}
                            <div class="replies">
                                {#each replies[note._id] as reply}
                                <div class="reply content">
                                    <div>
                                        <strong>{$userMap[reply.user] || reply.user}</strong>
                                        <small>
                                            {#if reply.ts}
                                                {formatTimestamp(reply.ts)}
                                            {:else}
                                                {reply.timestamp}
                                            {/if}
                                            {#if $session.user.email == reply.user}
                                                <span class="icon pointer" on:click={() => editComment(reply)}>
                                                    <i>✏️</i>
                                                </span>
                                            {/if}
                                        </small>
                                    </div>
                                    <div class="metadata">
                                        <MetadataTag metadata={reply.metadata} />
                                    </div>
                                    <div class="comment">
                                        {@html clean(markdown(reply.note))}
                                    </div>
                                </div>
                                {/each}
                            </div>
                        {/if}
                        <div class="buttons">
                            <div class="button is-small reply-button" on:click={() => replyTo(note)}>Reply</div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    {/each}
    <hr>
</div>

<div class="new">
    <form on:submit|preventDefault={addComment}>
        <textarea class="textarea" name="comment"></textarea>
        <div class="columns">
            <div class="column">
                <MetadataTag {metadata} />
            </div>
            <div class="column">
                <div class="buttons is-right">
                    <button class="button is-success">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<style>
    .messages {
        overflow-y: auto;
    }

    .new .buttons {
        padding-top: 10px;
    }

    .new {
        margin-top: 25px;
    }

    .comment {
        margin-top: .25rem;
    }

    .resolved {
        margin-top: .25rem;
    }

    .reply {
        margin-top: 5px;
    }

    .replies {
        margin-bottom: 5px;
        margin-left: 5px;
        padding-left: 5px;
        border-left: 2px solid gray;
    }

    .reply-button {
        margin-top: 5px;
    }
</style>
